
import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../common/services/api.config.json';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
@Injectable()
export class EmpresaTreeViewService {


    @Output() EmpId: EventEmitter<any> = new EventEmitter<any>();
    constructor(private http: HttpClient, private apiService: ApiService) { }

    getEmpresaTreeView(): Observable<RestResponse> {
        const url = `${API.EmpressaTreeView.getEmpresaTreeView}`;
        return this.apiService.get(url);
    }

    // SelectedEmploye pass
    getEmpresaID(id: any): void {
        this.EmpId.emit(id);
    }

    getEmpresa(id: number): Observable<RestResponse> {
        let url = `${API.Empresa.getEmpresa}`;
        url = url.replace('{id}', id.toString());
        return this.apiService.get(url);
    }

    getCurrentlySelectedEmpresa(): Observable<RestResponse> {
        // get empresa ID from tree view
        const empresaId = Number(localStorage.getItem("Empresa"));
        return this.getEmpresa(empresaId);
    }
}
